// from general.js
/* global loader qsParam isLoggedIn trim Handlebars isNonBlankCookie
getURLParam  */
// from JSP?
/* global userId teacherId proposalId donorIdsForImpactPhotoCheck displayedPercentFunded authorIds
isStudentLed numStudents teacherPossessivePronoun */

import { isUserTheTeacher } from '../utils/userUtils.js';
import {
    renderDonorProposalMessageForm,
    renderTeacherProposalMessageForm,
    shouldWeQueryTheServerForProposalMessageFormModel,
    userCameToPageFromTYPCoverLetter,
} from './proposalMessageFunctions.js';
import { isElementInViewport } from '../utils/visibleInViewport.js';

let invokedLoadProposalMessages = false;

function loadProposalMessages() {
    if ($('ol.js-activity').children().length > 0 || invokedLoadProposalMessages) {
        return;
    }
    invokedLoadProposalMessages = true;
    loader.showLoader('div.js-expand-mobile-activity');

    // Retrieving the project's proposal messages.
    let url = `${secureBaseURL}internal/project/${proposalId}/messages.json`;
    // Bringing over any query string parameters from the URL (e.g. if we're here from an e-mail link)
    if (location.search.length > 1) { url += '?' + location.search.substr(1); }
    // If the URL does not already have the `verifyShowPhotos` hash (which would be in an e-mail link),
    //   we should add it if the user is the teacher or a donor to the project.
    const formData = {};
    if (!qsParam.verifyShowPhotos && userCanSeeImpactPhotos()) {
        formData.verifyShowPhotos = window.btoa(proposalId + teacherId);
    }
    if (isLoggedIn() && userId) {
        formData.verifyDigitalGratitude = window.btoa(userId);
    }
    formData.projectPageUrl = location.href;
    $.ajax({
        url,
        method: 'GET',
        data: formData,
        success: projectTimelineCallback,
    });

    $(window).off('.loadPMEvent');
}

window.onhashchange = function () {
    if (location.hash.indexOf('pm') > -1 && trim($('#activity').html()) === '') {
        loadProposalMessages();
    }
};

export function userCanSeeImpactPhotos() {
    return isUserTheTeacher() || (donorIdsForImpactPhotoCheck && donorIdsForImpactPhotoCheck.includes(window.btoa(userId)));
}

function attachListenersForProposalMessages() {
    if (qsParam.lightbox != null) {
        loadProposalMessages();
    } else if ($('ol.js-activity').is(':visible')) {
        if (window.isiPad) { // end of momentum scrolling is hard to detect, so load proposal messages by default
            setTimeout(function () {
                loadProposalMessages();
            }, 500);
        } else {
            $(window).on('DOMContentLoaded.loadPMEvent load.loadPMEvent resize.loadPMEvent scroll.loadPMEvent', function () {
                setTimeout(function () {
                    if (isElementInViewport(document.getElementById('meetthedonors'), true)) {
                        loadProposalMessages();
                    }
                }, 100);
            });
        }
    } else {
        $('.js-expand-mobile-activity-toggle').on('click', function () {
            loadProposalMessages();
        });
    }
}

if (window.generalLoaded) {
    attachListenersForProposalMessages();
} else {
    window.addEventListener('generalLoaded', attachListenersForProposalMessages);
}

function getSalutation() {
    if (displayedPercentFunded <= 0) {
        return;
    }
    getProjectTimelineUserSettings();
}

function getProjectTimelineUserSettings() {
    let salutation = null;
    let numNames = 0;
    const namesToDisplay = [];
    const maxNamesToDisplay = 5;
    const pageUserId = userId || qsParam.pmaId;

    if (authorIds.hasOwnProperty(pageUserId)) {
        for (const aKey in authorIds[pageUserId].donationSalutations) {
            namesToDisplay.push(authorIds[pageUserId].donationSalutations[aKey]);
            numNames += 1;

            if (numNames > maxNamesToDisplay) {
                break;
            }
        }

        if (numNames > 0) {
            salutation = '';
        }
    }

    if (numNames > 1 && numNames <= maxNamesToDisplay) {
        salutation = namesToDisplay.slice(0, numNames - 1).join(', ');
        if (numNames > 2) {
            salutation = salutation + ',';
        }
        salutation = salutation + ' and ';
    }

    // If there are a lot of names, do not display them all.
    if (numNames > maxNamesToDisplay) {
        salutation = 'Friend';
    } else if (numNames > 0) {
        salutation = salutation + namesToDisplay[numNames - 1];
        salutation = salutation.replace("'", '&#39;');
    }

    // set ity and dty salutation to use donor's name, and only add greeting if there's text
    if (pageUserId != '' && parseInt(pageUserId) != teacherId && salutation != null && $('.js-teacher-message p').length > 0) {
        $('.js-teacher-message .user-greeting').remove();
        $('.js-teacher-message').prepend('<p class="user-greeting">Dear ' + salutation + ',</p>');
    } else {
        $('.js-teacher-message .user-greeting').remove();
    }

    if (!shouldWeQueryTheServerForProposalMessageFormModel(window.pmaId, window.pmaHash, salutation)) {
        $('#signin-invite').show();
        $('.reply-button').hide();
        $('.donationMessages.comment-form').remove();
        $('#leave-message-link').remove();
        const utmCampaign = getURLParam(location.href, 'utm_campaign');
        if (userCameToPageFromTYPCoverLetter(utmCampaign)) {
            $('#signin-invite .js-signin-link-text').show();
        } else {
            if (isNonBlankCookie('userId')) {
                $('#signin-invite .js-signin-link-text').hide();
            } else {
                $('#signin-invite .js-signin-link-text').show();
            }
        }

        return;
    }

    const formData = {};
    /* "proposal message author" (I think) id/hash.
     * As of 11-18-2020, it looks like these are currently unused in e-mail links,
     *  but we still provide them to SWU so they _could_ be used in the future.
     */
    if (window.pmaId) { formData.userId = window.pmaId; }
    if (window.pmaHash) { formData.userHash = window.pmaHash; }
    $.ajax({
        // This is a cross-origin request because the endpoint accesses user session
        url: `${secureBaseURL}internal/project/${proposalId}/message/new/reference-data.json`,
        method: 'GET',
        data: formData,
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
        success: displayReplyOptions,
    });
}

$(window).on('userCookiesReset', function () {
    getSalutation();
});

function scrollIntoViewAllowingForFundingBar(el) {
    const offsetTop = $(el).offset().top - 100;
    setTimeout(function () { $('html,body').animate({ scrollTop: offsetTop }, 200); }, 100);
}

function projectTimelineCallback(response) {
    if (response && response.data && response.data.threads) {
        let threadsString = '';
        let numDonations = 0;
        for (let i = 0; i < response.data.threads.length; i++) {
            const templateV = Handlebars.templates['proposalMessage.tmpl'];
            const context = response.data.threads[i];
            context.isStudentLed = isStudentLed; // Deprecated but retained for historical projects
            context.moreThanOneStudent = (numStudents && numStudents > 1);
            context.teacherPossessivePronoun = teacherPossessivePronoun;
            context.userId = userId || qsParam.pmaId;

            // If the teacher didn't really answer a given donation, and we show their default-message, we only want to
            // show that to the donor they're responding to (so it looks less spammy). This is a UX thing, not a
            // security thing, so we're okay with sleazy clientside checking.
            //
            // So: show if they seem to be the user...
            context.showDDM = (context.userId === context.original.author.id) ||
                // ... or if they requested *this* proposalMessage via the query-string (for signed-out users clicking
                // in via email)
                (context.responses && context.responses.some((response) => response.id == qsParam.msgId));

            context.isTeacher = userId === teacherId;
            const htmlV = templateV(context);
            threadsString += htmlV;
            if (context.original.sourceId == 1) {
                numDonations++;
            }

            if (context.original.author) {
                const authorSalutation = context.original.author.simpleSalutation;
                const authorId = context.original.author.id;

                if (!authorIds.hasOwnProperty(authorId)) {
                    authorIds[authorId] = { owner: null, donationSalutations: {} };
                }
                authorIds[authorId].owner = authorSalutation;

                if (context.original.honoree) {
                    const honoreeSalutation = context.original.honoree.simpleSalutation;
                    const honoreeId = context.original.honoree.id;

                    if (!authorIds.hasOwnProperty(honoreeId)) {
                        authorIds[honoreeId] = { owner: null, donationSalutations: {} };
                    }
                    authorIds[honoreeId].owner = honoreeSalutation;
                    authorIds[honoreeId].donationSalutations[honoreeSalutation] = honoreeSalutation;
                    authorIds[authorId].donationSalutations[honoreeSalutation] = honoreeSalutation;
                } else {
                    authorIds[authorId].donationSalutations[authorSalutation] = authorSalutation;
                }
            }
        }
        $('#activity').append(threadsString);

        // sometimes the proposal messages show a donation while the originating project page does not --
        // this is due to caching issues.  Hide 0 donors stats when that happens.
        if (numDonations > 0) {
            $('.js-be-the-first').remove();
            if ($('.js-num-donors strong').html() == '0') {
                $('.js-num-donors').hide();
            }
        }

        // lightbox param used to open a popup window, but now it's
        // used to scroll you to the right place on the page
        // As a fallback, scroll to element in url hash, done manually here in case this element was
        // dynamically loaded just now.
        const locationHash = window.location.hash;
        if (qsParam.lightbox != null) {
            if (document.getElementById(qsParam.lightbox)) {
                scrollIntoViewAllowingForFundingBar(document.getElementById(qsParam.lightbox));
            } else if ($('[name=' + qsParam.lightbox + ']').length > 0) {
                scrollIntoViewAllowingForFundingBar($('[name=' + qsParam.lightbox + ']')[0]);
            }
        } else if (locationHash.length > 1 && document.getElementById(locationHash.substring(1))) {
            scrollIntoViewAllowingForFundingBar(document.getElementById(locationHash.substring(1)));
        }
        getSalutation();

        $('.dg-thumbnail').on('click', function () {
            const mainPhotoId = '#' + this.id.replace('Thumbnail', 'Main');

            $(mainPhotoId).addClass('open');
            $(mainPhotoId + ' .image-close').on('click', function () {
                $(mainPhotoId).removeClass('open');
            });
        });

        loader.removeLoader();
    }
}

function displayReplyOptions(response) {
    if (response.success) {
        $('#signin-invite').hide();
        // storing this for later use
        $('body').data('userAuthor', JSON.stringify(response.data.author));
        if (response.data.author.type == 'T') {
            $('body').data('authorTeacher', JSON.stringify(response.data.author));
            $('.reply-button').each(function () {
                $(this).on('click', function (e) {
                    const originalId = $(e.target).data('original-id');
                    const originalAuthorSalutation = $(e.target).data('original-author-salutation');
                    renderTeacherProposalMessageForm(this, originalId, originalAuthorSalutation);
                });
            });
            $('.reply-button').css('display', 'inline-block');
        } else if (response.data.author.type == 'D') {
            renderDonorProposalMessageForm(response.data);
        }
    } else if (response.message === "User isn't logged in.") {
        $('#signin-invite').show();
        $('#signin-invite .js-signin-link-text').show();
        $('.reply-button').hide();
        $('.donationMessages.comment-form').remove();
        $('#leave-message-link').remove();
    }
}
